import { useMutation } from "@tanstack/react-query";
import { sendVisitSms } from "apis";

export default function useSendVisitSms() {
  return useMutation(sendVisitSms);
}
